/**
 * Array of prize options for the wheel
 * @type {import('../types').Prize[]}
 */
export const prizes = [
  {
    id: 'free-meal',
    name: 'Free Meal',
    value: 'Enjoy a complimentary meal on your next visit!',
    backgroundColor: '#F87171', // red-400
    textColor: '#FFFFFF'
  },
  {
    id: 'discount-20',
    name: '20% Off',
    value: '20% discount on your next purchase',
    backgroundColor: '#60A5FA', // blue-400
    textColor: '#FFFFFF'
  },
  {
    id: 'discount-10',
    name: '10% Off',
    value: '10% discount on your next purchase',
    backgroundColor: '#34D399', // emerald-400
    textColor: '#FFFFFF'
  },
  {
    id: 'free-dessert',
    name: 'Free Dessert',
    value: 'One complimentary dessert with your next meal',
    backgroundColor: '#A78BFA', // purple-400
    textColor: '#FFFFFF'
  },
  {
    id: 'free-drink',
    name: 'Free Drink',
    value: 'One complimentary drink with your next meal',
    backgroundColor: '#FBBF24', // amber-400
    textColor: '#FFFFFF'
  },
  {
    id: 'try-again',
    name: 'Try Again',
    value: 'Better luck next time!',
    backgroundColor: '#9CA3AF', // gray-400
    textColor: '#FFFFFF'
  },
  {
    id: 'loyalty-points',
    name: '50 Points',
    value: '50 bonus loyalty points added to your account',
    backgroundColor: '#F472B6', // pink-400
    textColor: '#FFFFFF'
  },
  {
    id: 'free-appetizer',
    name: 'Free Appetizer',
    value: 'One complimentary appetizer with your next meal',
    backgroundColor: '#2DD4BF', // teal-400
    textColor: '#FFFFFF'
  }
];

/**
 * Returns a random prize from the prizes array
 * @returns {import('../types').Prize}
 */
export const getRandomPrize = () => {
  // Define probabilities for each prize (must sum to 1)
  const probabilities = [
    0.05, // Free Meal (5%)
    0.10, // 20% Off (10%)
    0.15, // 10% Off (15%)
    0.10, // Free Dessert (10%)
    0.15, // Free Drink (15%)
    0.25, // Try Again (25%)
    0.10, // Loyalty Points (10%)
    0.10  // Free Appetizer (10%)
  ];
  
  // Generate a random number between 0 and 1
  const random = Math.random();
  
  // Determine which prize to return based on the random number and probabilities
  let cumulativeProbability = 0;
  for (let i = 0; i < prizes.length; i++) {
    cumulativeProbability += probabilities[i];
    if (random <= cumulativeProbability) {
      return prizes[i];
    }
  }
  
  // Fallback (should never reach here if probabilities sum to 1)
  return prizes[prizes.length - 1];
};
